module.exports = __webpack_public_path__ + "img/thumb_29.80339ccd.jpg";